import debounce from 'lodash.debounce'
import { RoomLastScroll } from '$logic/room-last-scroll/types'
import {
  cachedRoomLastScrolls,
  roomLastScrollDBStorage,
} from '$logic/room-last-scroll/storage'

type SaveRoomLastScrollFn = (
  roomId: string,
  roomLastScroll: RoomLastScroll,
) => void

const debouncedDBRequestsMap = new Map<
  string,
  { runDebounced: SaveRoomLastScrollFn; runImmediately: () => void }
>()

const SAVE_LAST_SCROLL_DEBOUNCE = 3000

export async function saveRoomLastScroll(
  roomId: string,
  roomLastScroll: RoomLastScroll,
) {
  cachedRoomLastScrolls[roomId] = roomLastScroll
  const fn = (roomId: string, roomLastScroll: RoomLastScroll) => {
    roomLastScrollDBStorage.set(roomId, roomLastScroll)
    debouncedDBRequestsMap.delete(roomId)
  }

  debouncedDBRequestsMap.set(roomId, {
    runDebounced:
      debouncedDBRequestsMap.get(roomId)?.runDebounced ||
      debounce(fn, SAVE_LAST_SCROLL_DEBOUNCE, {}),
    runImmediately: () => fn(roomId, roomLastScroll),
  })

  debouncedDBRequestsMap.get(roomId)?.runDebounced(roomId, roomLastScroll)
}

export function getRoomLastScroll(roomId: string): RoomLastScroll | undefined {
  return cachedRoomLastScrolls[roomId]
}

export async function initializeRoomScrolls() {
  const roomScrolls = await roomLastScrollDBStorage.getAll()
  roomScrolls.forEach(roomScroll => {
    cachedRoomLastScrolls[roomScroll.roomId] = {
      topViewPortMessageIid: roomScroll.topViewPortMessageIid,
      topViewPortMessageId: roomScroll.topViewPortMessageId,
      bottom: roomScroll.bottom,
    }
  })
}

window.addEventListener('beforeunload', () => {
  debouncedDBRequestsMap.forEach(({ runImmediately }) => {
    runImmediately()
  })
})
